import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=474a4bcb&scoped=true&"
import script from "./UpdateAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a4bcb",
  null
  
)

export default component.exports